import React from "react";

export default () => {
  return (
    <svg
      t="1677143516489"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9689"
    >
      <path
        d="M841.6 870.4l32-32V464h-64v342.4H217.6V217.6h560v-64H185.6l-32 32v652.8l32 32z"
        p-id="9690"
      ></path>
      <path
        d="M492.8 614.4l-188.8-188.8-44.8 44.8 211.2 211.2h44.8L912 284.8 864 240z"
        p-id="9691"
      ></path>
    </svg>
  );
};
